import React from "react";
import PropTypes from "prop-types";

import defaultAvatar from '../../../../../images/mywort/default-avatar.png';

export default class UserAvatarPresenter extends React.Component {

    static propTypes = {
        user                : PropTypes.object.isRequired,
        className           : PropTypes.string
    };

    render = () => {
        const avatar = this.props.user.avatarUrl || defaultAvatar;

        return  <img className={this.props.className} src={avatar} />
    }
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/user-avatar/UserAvatarPresenter.jsx